import React, { Component } from "react";
import Caro from "./Caro";
import Caromodal from "./Caromodal";
import Stater from "./Stater";
import Staterfarge from "./Staterfarge";

class ProductCard extends Component {
  state = { childValue: "" };
  handleChildChange = (val) => {
    this.setState({ childValue: val });
    // console.log("Running child handler " + val);
  };
  //

  render() {
    // const [curItem, setCurItem] = useState("");

    let hasThreePrices = false;

    let triggerTarget = `#id${this.props.caroId}-modal`;

    let prisEnd = "";

    let paypalLink = "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=";
    let vippsLink = "https://betal.vipps.no/";

    let paypalActive = false;
    let vippsActive = true;

    let emailItem = "";
    let numProds;
    let yellowPrice;

    let link1 = "";
    let link2 = "";
    let link3 = "";

    if (paypalActive) {
      link1 = `${paypalLink}${this.props.ppid1}`;
      link2 = `${paypalLink}${this.props.ppid2}`;
      link3 = `${paypalLink}${this.props.ppid3}`;
    }
    if (vippsActive) {
      link1 = `${vippsLink}${this.props.vippsId1}`;
      link2 = `${vippsLink}${this.props.vippsId2}`;
      link3 = `${vippsLink}${this.props.vippsId3}`;
    }

    if (!link1) throw new Error("Vipps or paypal links could not be found");

    // PRODUCT HAS ONE PRICE AND IS BRASS
    if (this.props.pris1 && this.props.pris2 === false && this.props.farge === "Messing") {
      numProds = (
        <div className={prisEnd}>
          <p>
            <h3>{this.props.pris1}</h3>
            <a href={link1} className="btn btn-block btn-lg btn-success mt-4">
              Kjøp nå
            </a>
          </p>
        </div>
      );
      yellowPrice = (
        <a href={link1} className="btn btn-sm btn-warning align-content-left">
          {this.props.pris1}
        </a>
      );
    }

    // PRODUCT HAS ONE PRICE AND IS BLACK
    if (this.props.pris1 && this.props.pris2 === false && this.props.farge === "Svart") {
      numProds = (
        <div className={prisEnd}>
          <p>
            <h3>{this.props.pris1}</h3>
            <a href={link1} className="btn btn-block btn-lg btn-success mt-4">
              Kjøp nå
            </a>
          </p>
        </div>
      );
      yellowPrice = (
        <a href={link1} className="btn btn-sm btn-warning align-content-left">
          {this.props.pris1}
        </a>
      );
    }

    // PRODUCT HAS TWO PRICE CATEGORIES
    if (this.props.pris1 && this.props.pris2 && this.props.pris3 === false) {
      numProds = (
        <p>
          <Staterfarge pris1={this.props.pris1} pris2={this.props.pris2} mppid1={link1} mppid2={link2} handleChildChange={this.handleChildChange} />
        </p>
      );
      yellowPrice = (
        <a href={link1} className="btn btn-sm btn-warning align-content-left">
          Flere varianter
        </a>
      );
    }

    // PRODUCT HAS THREE PRICE CATEGORIES
    if (this.props.pris1 && this.props.pris2 && this.props.pris3 /* && this.props.farge === 'Svart' */) {
      hasThreePrices = true;

      numProds = (
        <p>
          <Stater pris1={this.props.pris1} pris2={this.props.pris2} pris3={this.props.pris3} mppid1={link1} mppid2={link2} mppid3={link3} handleChildChange={this.handleChildChange} />
        </p>
      );

      yellowPrice = (
        <a href={link1} className="btn btn-sm btn-warning align-content-left">
          Flere varianter
        </a>
      );
    }

    let parsedTitle = this.props.tittel.split(" ").join("%20");

    let subject = "Request:%20Total%20costs%20for%20shipping%20to%20US";
    let mailRequest = `mailto:tor-vegard@smedenisund.no?subject=${subject}&body=Please%20provide%20total%20costs%20for%20sending%20the%20following%20item(s)%3A%0D%0A-%20${parsedTitle}%20${this.state.childValue}${hasThreePrices && this.state.childValue === "" ? "31cm" : ""}%0D%0A-%20Quantity%3A%201%0D%0A%0D%0AAddress%3A%0D%0A%3CPlease%20insert%20your%20shipping%20address%20here%3E`;

    return (
      <div className="col-xl-3 col-md-6 col-lg-4 d-flex align-items-stretch mb-3">
        <div className="ProductCard">
          <div className="card">
            <div className="d-md-none">
              <Caro key={this.props.caroId} activeCaro={this.props.activeCaro} caroId={this.props.caroId} caroId2={this.props.caroId2} imgs={this.props.caro} handleChildChange={this.handleChildChange} />
            </div>

            <div className="d-none d-md-block">
              <a href="" data-toggle="modal" data-target={triggerTarget}>
                <Caro key={this.props.caroId} activeCaro={this.props.activeCaro} caroId={this.props.caroId} caroId2={this.props.caroId2} imgs={this.props.caro} handleChildChange={this.handleChildChange} />
              </a>
            </div>

            <div className="card-body bg-light">
              <div className="d-none d-md-block">
                {/* hide on screens smaller than lg*/}
                {/* //<!-- Button trigger modal --> */}
                <a href="" data-toggle="modal" data-target={triggerTarget}>
                  <h3 className="card-title text-dark">{this.props.tittel}</h3>
                </a>
              </div>
              <div className="d-md-none">
                <h3 className="card-title">{this.props.tittel}</h3>
              </div>
              <small className="card-subtitle mt-2 mb-4">{this.props.beskrivelse}</small>
              <div className="card-text mb-2"></div>

              <Caromodal key={this.props.caroId} activeCaro={this.props.activeCaro} caroId={this.props.caroId} caroId2={this.props.caroId2} imgs={this.props.caro} tittel={this.props.tittel} link1={link1} link2={link2} link3={link3} pris1={this.props.pris1} pris2={this.props.pris2} pris3={this.props.pris3} farge={this.props.farge} handleChildChange={this.handleChildChange} />

              {numProds}

              <p className="text-secondary">
                <small>Pris inkluderer porto</small>
              </p>
              <p className="text-secondary">
                <small>
                  <strong className="text-danger">⚠</strong> Please <a href={mailRequest}>contact us</a> before ordering from the US.
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductCard;
